
import { IUserSession } from '../../../helpers/user-session'

import { LoggerService } from '../../common/common.module'

import { GroupingLocationCreateEditController } from './grouping-locations-create-edit.directive.controller'

import { GroupingLocationHelper } from '../grouping-locations.helper'

//#region Asset Imports

import * as TEMPLATE from './grouping-locations-create-edit.tpl.html'

//#endregion

// Setup

export class GroupingLocationCreateEditDirective implements ng.IDirective {

    restrict = 'E'

    controller = ['$scope', '$q', '$timeout', 'logger', 'userSession', (
        $scope: any,
        $q: ng.IQService,
        $timeout: ng.ITimeoutService,
        logger: LoggerService,
        userSession: IUserSession
    ) => new GroupingLocationCreateEditController(
        $scope,
        $q,
        $timeout,
        logger,
        userSession,
        GroupingLocationHelper.REFERENCE_TYPE,
        GroupingLocationHelper.SIMAX_MODULE_NAME
    )]

    template = TEMPLATE
}

// Setup End